import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface StoryHistoryOption {
  ids: string;
  patientid: number | string;
  description: string;
}

interface StoryState {
  history: StoryHistoryOption[];
}

const initialState: StoryState = {
  history: [],
};

const StoryIdsSlice = createSlice({
  name: "studyHistory",
  initialState,
  reducers: {
    addId: (state, action: PayloadAction<StoryHistoryOption>) => {
      const index = state.history.findIndex(item => item.ids === action.payload.ids);

      if (index !== -1) {
        state.history.splice(index, 1); // 기존 위치 제거
      }

      state.history.unshift(action.payload); // 맨 앞에 추가
    },
  }
});

export const { addId } = StoryIdsSlice.actions;
export default StoryIdsSlice.reducer;
